import { Snackbar, Alert, Stack } from '@mui/material'
import { useToastStore } from '../store/toastStore'

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)
  const remove = useToastStore((s) => s.remove)

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        bottom: { xs: 12, sm: 24 },
        right: { xs: 12, sm: 24 },
        left: { xs: 12, sm: 'auto' },
        zIndex: 2000,
        pointerEvents: 'none',
      }}
    >
      {toasts.map((t) => (
        <Snackbar
          key={t.id}
          open
          autoHideDuration={t.duration}
          onClose={() => remove(t.id)}
          sx={{ position: 'static', pointerEvents: 'auto' }}
        >
          <Alert
            severity={t.severity}
            variant="filled"
            onClose={() => remove(t.id)}
            sx={{ width: '100%', fontWeight: 600, minWidth: { sm: 300 }, boxShadow: '0 12px 32px rgba(16,42,67,0.18)' }}
          >
            {t.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  )
}
